import { create } from 'zustand';
import { Moment } from 'moment/moment';

import { ESortOrder, EStatusStr } from '@src/emp-3.0/types';
import { createSetState, removeInvalidSelectedList } from '@src/emp-3.0/utils/management';
import { IMetricsVersion } from '@src/emp-3.0/domain/metrics-template/types';
import { IFrontendGeneratedFields } from '@src/emp-3.0/components/Management';

interface ISelectedMetric extends IMetricsVersion, IFrontendGeneratedFields {}

interface IUseMetricsManagementStoreProps {
  openBulkAction: boolean;
  setOpenBulkAction: (openBulkAction: boolean) => void;
  totalCount: number;
  setTotalCount: (totalCount: number) => void;
  // multiple selection operation
  selectedList: ISelectedMetric[];
  setSelectedList: (selectedList: ISelectedMetric[]) => void;
  setRemoveInvalidSelectedList: (allSelectedList: ISelectedMetric[]) => void;
  // search
  searchText: string;
  setSearchText: (searchText: string) => void;
  // sort
  sort: { key: string; order: number };
  setSort: (sort: { key: string; order: number }) => void;
  // filter condition
  showFilter: boolean;
  setShowFilter: (showFilter: boolean) => void;
  status: EStatusStr;
  setStatus: (status: EStatusStr) => void;
  updateDate: Moment[];
  setUpdateDate: (updateDate: Moment[]) => void;
  deployDate: Moment[];
  setDeployDate: (deployDate: Moment[]) => void;
  createdBy: string;
  setCreatedBy: (createdBy: string) => void;
  updatedBy: string;
  setUpdatedBy: (updatedBy: string) => void;
  metricsType: EStatusStr;
  setMetricsType: (metricsType: EStatusStr) => void;
  // reset
  resetFilter: () => void;
  resetStore: () => void;
}

export const useMetricsManagementStore = create<IUseMetricsManagementStoreProps>((set) => ({
  totalCount: 0,
  openBulkAction: false,

  setTotalCount: createSetState(set, 'totalCount'),
  setOpenBulkAction: createSetState(set, 'openBulkAction'),

  // multiple selection operation
  selectedList: [],
  setSelectedList: createSetState(set, 'selectedList'),
  setRemoveInvalidSelectedList: removeInvalidSelectedList(set),

  // search
  searchText: '',
  setSearchText: createSetState(set, 'searchText'),

  // sort
  sort: { key: '', order: ESortOrder.NORMAL },
  setSort: createSetState(set, 'sort'),

  // filter condition
  showFilter: false,
  status: EStatusStr.ALL,
  updateDate: [],
  deployDate: [],
  createdBy: 'All',
  updatedBy: 'All',
  metricsType: EStatusStr.ALL,

  setShowFilter: createSetState(set, 'showFilter'),
  setStatus: createSetState(set, 'status'),
  setUpdateDate: createSetState(set, 'updateDate'),
  setDeployDate: createSetState(set, 'deployDate'),
  setCreatedBy: createSetState(set, 'createdBy'),
  setUpdatedBy: createSetState(set, 'updatedBy'),
  setMetricsType: createSetState(set, 'metricsType'),

  // reset
  resetFilter: () =>
    set(() => ({
      status: EStatusStr.ALL,
      updateDate: [],
      deployDate: [],
      createdBy: 'All',
      updatedBy: 'All',
      metricsType: EStatusStr.ALL,
    })),

  resetStore: () =>
    set(() => ({
      totalCount: 0,
      selectedList: [],
      searchText: '',
      showFilter: false,
      status: EStatusStr.ALL,
      updateDate: [],
      deployDate: [],
      createdBy: 'All',
      updatedBy: 'All',
      metricsType: EStatusStr.ALL,
      sort: { key: '', order: ESortOrder.NORMAL },
    })),
}));
